export function getUnleashFeatureWithPodletPrefix(nameId: string): string {
    return 'displayads-podlet-horseshoe.' + nameId;
}

export const UNLEASH_FEATURE_NAMES = {
    appNexus9826: 'appNexus9826',
    astFallback: 'ast.fallback',
    enableTransparencyCogwheel: 'enableTransparencyCogwheel',
    safeFrame: 'safeFrame',
    EAad: 'EAad',
    enableAdIntervalVariant: 'enableAdIntervalVariant',
    enableUpdatedExternalIdKeyword: 'enableUpdatedExternalIdKeyword',
    enableMarketContentDesignExperiment:
        'enableMarketContentDesignExperimentV12',
    killSwitch: 'killswitch.banners',
    enableRelevantDigitalAd: 'enableRelevantDigitalAd',
    enableProximityIsZeroBanner: 'enableProximityIsZeroBanner',
    contentMarketingLeftSideImage: 'contentMarketingLeftSideImage',
    contentMarketingFinnLogoExperiment: 'contentMarketingFinnLogoExperiment',
};
